import { enAU } from "date-fns/locale/en-AU";
import { enGB } from "date-fns/locale/en-GB";
import { enNZ } from "date-fns/locale/en-NZ";
import { enUS } from "date-fns/locale/en-US";
import { es } from "date-fns/locale/es";
import { fr } from "date-fns/locale/fr";
import { hi } from "date-fns/locale/hi";
import { ptBR } from "date-fns/locale/pt-BR";
import { ru } from "date-fns/locale/ru";

// The single list of date-fns locales the app ships. apps/web-app aliases the whole
// "date-fns/locale" barrel onto this module in craco.config.js, because rc-picker's date-fns
// adapter requires that barrel from CommonJS and indexes it by name — unshakeable, so without
// the alias all 96 locales end up in the entry chunk. The named re-exports below are what that
// alias resolves; the object is for our own lookups.
export { enAU, enGB, enNZ, enUS, es, fr, hi, ptBR, ru };

// Order matters. findLibraryLocale picks the first entry whose language matches when the target
// locale carries no region (e.g. "en"), so enUS has to come before the other English variants.
// eslint-disable-next-line perfectionist/sort-objects
export const dateFnsLocales = { enUS, enGB, enAU, enNZ, es, fr, hi, ru, ptBR } as const;

export type DateFnsLocale = (typeof dateFnsLocales)[keyof typeof dateFnsLocales];
